module.exports = __webpack_public_path__ + "img/145.99030ff0.jpg";